export const functionNames = [
  "abs",
  "sum",
  "min",
  "max",
  "average",
  "if",
  "ifs",
  "and",
  "or",
  "not",
  "choose",
  "sumifs",
  "averageifs",
  "formulatext",
  "count",
  "counta",
  "countifs",
  "column",
  "columns",
  "row",
  "rows",
  "left",
  "right",
  "mid",
  "len",
  "replace",
  "round",
  "index",
  "match",
  "getifs",
  "hyperlink",
  "date",
];

export const precedence = {
  ",": 1,
  ":": 2,
  "|": 3,
  "&": 4,
  "=": 8,
  "<": 9,
  "<=": 9,
  ">": 9,
  ">=": 9,
  "+": 11,
  "-": 11,
  "*": 12,
  "/": 12,
  "%": 13,
  "^": 13,
};
export const operatorList = ["&", "=", "<", "<=", ">", ">=", "+", "-", "*", "/", "^", "%", ",", ":"];
export const singleOperands = ["%"];

export const functionArguments = {
  // Smart Search Functions,
  "Add Arrow": { required: ["Start Player", "End Player"] },
  "Font Size": { required: ["Size"] },
  "Add Player": { required: ["Player"], repeated: ["Player"] },
  "Filter Table": { required: ["Value"], repeated: ["Value"] },
  "Rename Table": { required: ["Name"] },
  "Edit Player": { required: ["Player"] },
  "Add View": { required: ["Title", "Icon"] },
  Width: { required: ["px"] },
  Height: { required: ["px"] },

  // hyperformula functions
  abs: { required: ["number"] },
  acos: { required: ["number"] },
  acosh: { required: ["number"] },
  acot: { required: ["number"] },
  acoth: { required: ["number"] },
  address: { required: ["number", "column_num", "[abs_num]", "[a1]", "[sheet_text]"] },
  and: { required: ["logical1"], repeated: ["logical"] },
  arabic: { required: ["text"] },
  array_constrain: { required: ["array", "height", "width"] },
  arrayformula: { required: ["array", "height", "width"] },
  asin: { required: ["number"] },
  asinh: { required: ["number"] },
  atan: { required: ["number"] },
  atan2: { required: ["x_num", "y_num"] },
  atanh: { required: ["number"] },
  avedev: { required: ["number1"], repeated: ["number"] },
  average: { required: ["number1"], repeated: ["number"] },
  averagea: { required: ["value1"], repeated: ["value"] },
  averageif: { required: ["range", "criteria", "[average_range]"] },
  averageifs: { required: ["average_range", "criteria_range1", "criteria1"], repeated: ["criteria_range", "criteria"] },
  base: { required: ["number", "radix", "[min_length]"] },
  besseli: { required: ["x", "n"] },
  besselj: { required: ["x", "n"] },
  besselk: { required: ["x", "n"] },
  bessely: { required: ["x", "n"] },
  "beta.dist": { required: ["x", "alpha", "beta", "cumulative", "[A]", "[B]"] },
  "beta.inv": { required: ["probability", "alpha", "beta", "[A]", "[B]"] },
  bin2dec: { required: ["number"] },
  bin2hex: { required: ["number", "[places]"] },
  bin2oct: { required: ["number", "[places]"] },
  "binom.dist": { required: ["number_s", "trials", "probability_s", "cumulative"] },
  "binom.inv": { required: ["trials", "probability_s", "alpha"] },
  binomdist: { required: ["number_s", "trials", "probability_s", "cumulative"] },
  bitand: { required: ["number1", "number2"] },
  bitlshift: { required: ["number", "shift_amount"] },
  bitor: { required: ["number1", "number2"] },
  bitrshift: { required: ["number", "shift_amount"] },
  bitxor: { required: ["number1", "number2"] },
  ceiling: { required: ["number", "significance"] },
  "ceiling.math": { required: ["number", "[significance]", "[mode]"] },
  "ceiling.precise": { required: ["number", "[significance]"] },
  char: { required: ["number"] },
  chidist: { required: ["x", "deg_freedom"] },
  chidistrt: { required: ["x", "degrees"] },
  chiinv: { required: ["probability", "deg_freedom"] },
  chiinvrt: { required: ["probability", "deg_freedom"] },
  "chisq.dist": { required: ["x", "deg_freedom", "cumulative"] },
  "chisq.dist.rt": { required: ["x", "deg_freedom"] },
  "chisq.inv": { required: ["probability", "deg_freedom"] },
  "chisq.inv.rt": { required: ["probability", "deg_freedom"] },
  "chisq.test": { required: ["actual_range", "expected_range"] },
  chitest: { required: ["actual_range", "expected_range"] },
  choose: { required: ["index_num", "value1"], repeated: ["value"] },
  clean: { required: ["text"] },
  code: { required: ["text"] },
  column: { required: ["[reference]"] },
  columns: { required: ["array"] },
  combin: { required: ["number", "number_chosen"] },
  combina: { required: ["number", "number_chosen"] },
  complex: { required: ["real_num", "i_num", "[suffix]"] },
  concatenate: { required: ["text1"], repeated: ["text"] },
  confidence: { required: ["alpha", "standard_dev", "size"] },
  "confidence.norm": { required: ["alpha", "standard_dev", "size"] },
  "confidence.t": { required: ["alpha", "standard_dev", "size"] },
  correl: { required: ["array1", "array2"] },
  cos: { required: ["number"] },
  cosh: { required: ["number"] },
  cot: { required: ["number"] },
  coth: { required: ["number"] },
  count: { required: ["value1"], repeated: ["value"] },
  counta: { required: ["value1"], repeated: ["value"] },
  countblank: { required: ["range"] },
  countif: { required: ["range", "criteria"] },
  countifs: { required: ["criteria_range1", "criteria1"], repeated: ["criteria_range", "criteria"] },
  countunique: { required: ["value1"], repeated: ["value"] },
  covar: { required: ["array1", "array2"] },
  "covariance.p": { required: ["array1", "array2"] },
  "covariance.s": { required: ["array1", "array2"] },
  covariancep: { required: ["array1", "array2"] },
  covariances: { required: ["array1", "array2"] },
  critbinom: { required: ["trials", "probability_s", "alpha"] },
  csc: { required: ["number"] },
  csch: { required: ["number"] },
  cumimpt: { required: ["rate", "nper", "pv", "start_period", "end_period", "type"] },
  cumprinc: { required: ["rate", "nper", "pv", "start_period", "end_period", "type"] },
  date: { required: ["year", "month", "day"] },
  datedif: { required: ["date1", "date2", "unit"] },
  datevalue: { required: ["date_text"] },
  day: { required: ["serial_number"] },
  days: { required: ["end_date", "start_date"] },
  days360: { required: ["start_date", "end_date", "[method]"] },
  db: { required: ["cost", "salvage", "life", "period", "[month]"] },
  ddb: { required: ["cost", "salvage", "life", "period", "[factor]"] },
  dec2bin: { required: ["number", "[places]"] },
  dec2hex: { required: ["number", "[places]"] },
  dec2oct: { required: ["number", "[places]"] },
  decimal: { required: ["number", "radix"] },
  degrees: { required: ["angle"] },
  delta: { required: ["number1", "[number2]"] },
  devsq: { required: ["number1"], repeated: ["number"] },
  dollarde: { required: ["fractional_dollar", "fraction"] },
  dollarfr: { required: ["decimal_dollar", "fraction"] },
  edate: { required: ["start_date", "months"] },
  effect: { required: ["nominal_rate", "npery"] },
  eomonth: { required: ["start_date", "months"] },
  erf: { required: ["lower_limit", "[upper_limit]"] },
  erfc: { required: ["x"] },
  even: { required: ["number"] },
  exact: { required: ["text1", "text2"] },
  exp: { required: ["number"] },
  "expon.dist": { required: ["x", "lambda", "cumulative"] },
  expondist: { required: ["x", "lambda", "cumulative"] },
  "f.dist": { required: ["x", "deg_freedom1", "deg_freedom2", "cumulative"] },
  "f.dist.rt": { required: ["x", "deg_freedom1", "deg_freedom2"] },
  "f.inv": { required: ["probability", "deg_freedom1", "deg_freedom2"] },
  "f.inv.rt": { required: ["probability", "deg_freedom1", "deg_freedom2"] },
  "f.test": { required: ["array1", "array2"] },
  fact: { required: ["number"] },
  factdouble: { required: ["number"] },
  false: { required: [] },
  fdist: { required: ["x", "deg_freedom1", "deg_freedom2"] },
  fdistrt: { required: ["x", "deg_freedom1", "deg_freedom2"] },
  filter: { required: ["source_array", "bool_array1"], repeated: ["bool_array"] },
  find: { required: ["find_text", "within_text", "[start_num]"] },
  finv: { required: ["probability", "deg_freedom1", "deg_freedom2"] },
  finvrt: { required: ["probability", "deg_freedom1", "deg_freedom2"] },
  fisher: { required: ["x"] },
  floor: { required: ["number", "significance"] },
  "floor.math": { required: ["number", "[significance]", "[mode]"] },
  "floor.precise": { required: ["number", "[significance]"] },
  formulatext: { required: ["reference"] },
  ftest: { required: ["array1", "array2"] },
  fv: { required: ["rate", "nper", "pmt", "[pv]", "[type]"] },
  fvschedule: { required: ["principal", "schedule"] },
  gamma: { required: ["x"] },
  "gamma.dist": { required: ["x", "alpha", "beta", "cumulative"] },
  gammadist: { required: ["x", "alpha", "beta", "cumulative"] },
  "gamma.inv": { required: ["probability", "alpha", "beta"] },
  gammainv: { required: ["probability", "alpha", "beta"] },
  "gamma.precise": { required: ["number"] },
  gauss: { required: ["x"] },
  gcd: { required: ["number1"], repeated: ["number"] },
  geomean: { required: ["number1"], repeated: ["number"] },
  getifs: {
    required: ["data_range", "function", "behaviour", "criteria_range1", "criteria1"],
    repeated: ["criteria_range", "criteria"],
  },
  aggregate: {
    required: ["function", "behavior", "data_range"],
    repeated: ["ref"],
  },
  harmean: { required: ["number1"], repeated: ["number"] },
  hex2bin: { required: ["number", "[places]"] },
  hex2dec: { required: ["number"] },
  hex2oct: { required: ["number", "[places]"] },
  "hf.add": { required: ["number1", "number2"] },
  "hf.concat": { required: ["string1", "string2"] },
  "hf.divide": { required: ["number1", "number2"] },
  "hf.eq": { required: ["value1", "value2"] },
  "hf.gt": { required: ["value1", "value2"] },
  "hf.gte": { required: ["value1", "value2"] },
  "hf.lt": { required: ["value1", "value2"] },
  "hf.lte": { required: ["value1", "value2"] },
  "hf.minus": { required: ["number1", "number2"] },
  "hf.multiply": { required: ["number1", "number2"] },
  "hf.ne": { required: ["value1", "value2"] },
  "hf.pow": { required: ["number1", "number2"] },
  "hf.uminus": { required: ["number"] },
  "hf.unary_percent": { required: ["number"] },
  "hf.uplus": { required: ["number"] },
  hlookup: { required: ["lookup_value", "table_array", "row_index_num", "[range_lookup]"] },
  hour: { required: ["serial_number"] },
  hyperlink: { required: ["link_location", "[friendly_name]"] },
  "hypgeom.dist": { required: ["sample_s", "number_sample", "population_s", "number_pop", "cumulative"] },
  hypgeomdist: { required: ["sample_s", "number_sample", "population_s", "number_pop"] },
  if: { required: ["logical_test", "value_if_true", "value_if_false"] },
  iferror: { required: ["value", "value_if_error"] },
  ifna: { required: ["value", "value_if_na"] },
  ifs: { required: ["logical_test1", "value_if_true1"], repeated: ["logical_test", "value_if_true"] },
  imabs: { required: ["inumber"] },
  imaginary: { required: ["inumber"] },
  imargument: { required: ["inumber"] },
  imconjugate: { required: ["inumber"] },
  imcos: { required: ["inumber"] },
  imcosh: { required: ["inumber"] },
  imcot: { required: ["inumber"] },
  imcsc: { required: ["inumber"] },
  imcsch: { required: ["inumber"] },
  imdiv: { required: ["inumber1", "inumber2"] },
  imexp: { required: ["inumber"] },
  imln: { required: ["inumber"] },
  imlog10: { required: ["inumber"] },
  imlog2: { required: ["inumber"] },
  impower: { required: ["inumber", "number"] },
  improduct: { required: ["inumber1"], repeated: ["inumber"] },
  imreal: { required: ["inumber"] },
  imsec: { required: ["inumber"] },
  imsech: { required: ["inumber"] },
  imsin: { required: ["inumber"] },
  imsinh: { required: ["inumber"] },
  imsqrt: { required: ["inumber"] },
  imsub: { required: ["inumber1", "inumber2"] },
  imsum: { required: ["inumber1"], repeated: ["inumber"] },
  imtan: { required: ["inumber"] },
  index: { required: ["reference", "row_num", "[column_num]"] },
  int: { required: ["number"] },
  interval: { required: ["seconds"] },
  ipmt: { required: ["rate", "per", "nper", "pv", "[fv]", "[type]"] },
  isbinary: { required: ["value"] },
  isblank: { required: ["value"] },
  iserr: { required: ["value"] },
  iserror: { required: ["value"] },
  iseven: { required: ["number"] },
  isformula: { required: ["reference"] },
  islogical: { required: ["value"] },
  isna: { required: ["value"] },
  isnontext: { required: ["value"] },
  isnumber: { required: ["value"] },
  "iso.ceiling": { required: ["number", "[significance]"] },
  isodd: { required: ["value"] },
  isoweeknum: { required: ["date"] },
  ispmt: { required: ["rate", "per", "nper", "pv"] },
  isref: { required: ["value"] },
  istext: { required: ["value"] },
  large: { required: ["array", "k"] },
  lcm: { required: ["number1"], repeated: ["number"] },
  left: { required: ["text", "[num_chars]"] },
  len: { required: ["text"] },
  ln: { required: ["number"] },
  log: { required: ["number", "[base]"] },
  log10: { required: ["number"] },
  loginv: { required: ["probability", "mean", "standard_dev"] },
  "lognorm.dist": { required: ["x", "mean", "standard_dev", "cumulative"] },
  "lognorm.inv": { required: ["probability", "mean", "standard_dev"] },
  lognormdist: { required: ["x", "mean", "standard_dev"] },
  lognorminv: { required: ["probability", "mean", "standard_dev"] },
  lower: { required: ["text"] },
  match: { required: ["lookup_value", "lookup_array", "[match_type]"] },
  max: { required: ["number1"], repeated: ["number"] },
  maxa: { required: ["value1"], repeated: ["value"] },
  maxifs: { required: ["max_range", "criteria_range1", "criteria1"], repeated: ["criteria_range", "criteria"] },
  maxpool: { required: ["range", "window_size", "stride"] },
  median: { required: ["number1"], repeated: ["number"] },
  medianpool: { required: ["range", "window_size", "stride"] },
  mid: { required: ["text", "start_num", "num_chars"] },
  min: { required: ["number1"], repeated: ["number"] },
  mina: { required: ["value1"], repeated: ["value"] },
  minifs: { required: ["min_range", "criteria_range1", "criteria1"], repeated: ["criteria_range", "criteria"] },
  minute: { required: ["serial_number"] },
  mirr: { required: ["values", "finance_rate", "reinvest_rate"] },
  mmult: { required: ["array1", "array2"] },
  mod: { required: ["number", "divisor"] },
  month: { required: ["serial_number"] },
  mround: { required: ["number", "multiple"] },
  multinominal: { required: ["number1"], repeated: ["number"] },
  na: { required: [] },
  "negbinom.dist": { required: ["number_f", "number_s", "probability_s", "cumulative"] },
  negbinomdist: { required: ["number_f", "number_s", "probability_s"] },
  networkdays: { required: ["start_date", "end_date", "[holidays]"] },
  "networkdays.intl": { required: ["start_date", "end_date", "[weekend]", "[holidays]"] },
  nominal: { required: ["effect_rate", "npery"] },
  "norm.dist": { required: ["x", "mean", "standard_dev", "cumulative"] },
  "norm.inv": { required: ["probability", "mean", "standard_dev"] },
  "norm.s.dist": { required: ["z", "cumulative"] },
  "norm.s.inv": { required: ["probability"] },
  normdist: { required: ["x", "mean", "standard_dev", "cumulative"] },
  norminv: { required: ["probability", "mean", "standard_dev"] },
  normsdist: { required: ["z"] },
  normsinv: { required: ["probability"] },
  not: { required: ["logical"] },
  now: { required: [""] },
  nper: { required: ["rate", "pmt", "pv", "[fv]", "[type]"] },
  npv: { required: ["rate", "value1"], repeated: ["value"] },
  oct2bin: { required: ["number", "[places]"] },
  oct2dec: { required: ["number"] },
  oct2hex: { required: ["number", "[places]"] },
  odd: { required: ["number"] },
  or: { required: ["logical1"], repeated: ["logical"] },
  pduration: { required: ["rate", "pv", "fv"] },
  pearson: { required: ["array1", "array2"] },
  phi: { required: ["x"] },
  pi: { required: [] },
  pmt: { required: ["rate", "nper", "pv", "[fv]", "[type]"] },
  poisson: { required: ["x", "mean", "cumulative"] },
  "poisson.dist": { required: ["x", "mean", "cumulative"] },
  poissondist: { required: ["x", "mean", "cumulative"] },
  power: { required: ["number", "power"] },
  ppmt: { required: ["rate", "per", "nper", "pv", "[fv]", "[type]"] },
  product: { required: ["number1"], repeated: ["number"] },
  proper: { required: ["text"] },
  pv: { required: ["rate", "nper", "pmt", "[fv]", "[type]"] },
  quotient: { required: ["numerator", "denominator"] },
  radians: { required: ["angle"] },
  rand: { required: [] },
  randbetween: { required: ["bottom", "top"] },
  rate: { required: ["nper", "pmt", "pv", "[fv]", "[type]", "[guess]"] },
  replace: { required: ["old_text", "start_num", "num_chars", "new_text"] },
  rept: { required: ["text", "number_times"] },
  right: { required: ["text", "[num_chars]"] },
  roman: { required: ["number", "[form]"] },
  round: { required: ["number", "num_digits"] },
  rounddown: { required: ["number", "num_digits"] },
  roundup: { required: ["number", "num_digits"] },
  row: { required: ["[reference]"] },
  rows: { required: ["array"] },
  rri: { required: ["nper", "pv", "fv"] },
  rsq: { required: ["known_ys", "knonwn_xs"] },
  search: { required: ["find_text", "within_text", "[start_num]"] },
  sec: { required: ["number"] },
  sech: { required: ["number"] },
  second: { required: ["serial_number"] },
  seriessum: { required: ["x", "n", "m", "coefficients"] },
  sheet: { required: ["[value]"] },
  sheets: { required: ["[reference]"] },
  sign: { required: ["number"] },
  sin: { required: ["number"] },
  sinh: { required: ["number"] },
  skew: { required: ["number1"], repeated: ["number"] },
  "skew.p": { required: ["number1"], repeated: ["number"] },
  sln: { required: ["cost", "salvage", "life"] },
  slope: { required: ["known_ys", "known_xs"] },
  small: { required: ["array", "k"] },
  split: { required: ["text", "index"] },
  sqrt: { required: ["number"] },
  sqrtpi: { required: ["number"] },
  standardize: { required: ["x", "mean", "standard_dev"] },
  stdev: { required: ["number1"], repeated: ["number"] },
  "stdev.p": { required: ["number1"], repeated: ["number"] },
  "stdev.s": { required: ["number1"], repeated: ["number"] },
  stdeva: { required: ["value1"], repeated: ["value"] },
  stdevp: { required: ["number1"], repeated: ["number"] },
  stdevpa: { required: ["value1"], repeated: ["value"] },
  stdevs: { required: ["value1"], repeated: ["value"] },
  substitute: { required: ["text", "old_text", "new_text", "[instance_num]"] },
  subtotal: { required: ["function_num", "ref1"], repeated: ["ref"] },
  sum: { required: ["number1"], repeated: ["number"] },
  sumif: { required: ["range", "criteria", "[sum_range]"] },
  sumifs: { required: ["sum_range", "criteria_range1", "criteria1"], repeated: ["criteria_range", "criteria"] },
  sumproduct: { required: ["array1"], repeated: ["array"] },
  sumsq: { required: ["number1"], repeated: ["number"] },
  sumx2my2: { required: ["range1", "range2"] },
  sumx2py2: { required: ["range1", "range2"] },
  sumxmy2: { required: ["range1", "range2"] },
  switch: { required: ["expression", "value1", "result1"], repeated: ["default_or_value", "result"] },
  syd: { required: ["cost", "salvage", "life", "per"] },
  t: { required: ["value"] },
  "t.dist": { required: ["x", "deg_freedom", "cumulative"] },
  "t.dist.2t": { required: ["x", "deg_freedom"] },
  "t.dist.rt": { required: ["x", "deg_freedom"] },
  "t.inv": { required: ["probability", "deg_freedom"] },
  "t.inv.2t": { required: ["probability", "deg_freedom"] },
  "t.test": { required: ["array1", "array2", "tails", "type"] },
  tan: { required: ["number"] },
  tanh: { required: ["number"] },
  tbilleq: { required: ["settlement", "maturity", "discount"] },
  tbillprice: { required: ["settlement", "maturity", "discount"] },
  tbillyield: { required: ["settlement", "maturity", "pr"] },
  tdist: { required: ["x", "deg_freedom", "tails"] },
  tdist2t: { required: ["x", "deg_freedom"] },
  tdistrt: { required: ["x", "deg_freedom"] },
  text: { required: ["value", "format_text"] },
  time: { required: ["hour", "minute", "second"] },
  timevalue: { required: ["text"] },
  tinv: { required: ["probability", "deg_freedom"] },
  tinv2t: { required: ["probability", "deg_freedom"] },
  today: { required: [] },
  transpose: { required: ["array"] },
  trim: { required: ["text"] },
  true: { required: [""] },
  trunc: { required: ["number", "[num_digits]"] },
  ttest: { required: ["array1", "array2", "tails", "type"] },
  unichar: { required: ["number"] },
  unicode: { required: ["text"] },
  upper: { required: ["text"] },
  var: { required: ["number1"], repeated: ["number"] },
  "var.p": { required: ["number1"], repeated: ["number"] },
  "var.s": { required: ["number1"], repeated: ["number"] },
  vara: { required: ["value1"], repeated: ["value"] },
  varp: { required: ["number1"], repeated: ["number"] },
  varpa: { required: ["value1"], repeated: ["value"] },
  vars: { required: ["number1"], repeated: ["number"] },
  version: { required: [] },
  vlookup: { required: ["lookup_value", "table_array", "col_index_num", "[range_lookup]"] },
  xnpv: { required: ["rate", "values", "dates"] },
  xor: { required: ["logical1"], repeated: ["logical"] },
  year: { required: ["serial_number"] },
  yearfrac: { required: ["start_date", "end_date", "[basis]"] },
  "z.test": { required: ["array", "x", "[sigma]"] },
  ztest: { required: ["array", "x", "[sigma]"] },
};

export const formulaNames = [
  { title: "abs", icon: "icon-function-variant" },
  { title: "sum", icon: "icon-function-variant" },
  { title: "min", icon: "icon-function-variant" },
  { title: "max", icon: "icon-function-variant" },
  { title: "average", icon: "icon-function-variant" },
  { title: "if", icon: "icon-function-variant" },
  { title: "ifs", icon: "icon-function-variant" },
  { title: "and", icon: "icon-function-variant" },
  { title: "or", icon: "icon-function-variant" },
  { title: "not", icon: "icon-function-variant" },
  { title: "choose", icon: "icon-function-variant" },
  { title: "sumifs", icon: "icon-function-variant" },
  { title: "averageifs", icon: "icon-function-variant" },
  { title: "formulaText", icon: "icon-function-variant" },
  { title: "count", icon: "icon-function-variant" },
  { title: "counta", icon: "icon-function-variant" },
  { title: "countifs", icon: "icon-function-variant" },
  { title: "column", icon: "icon-function-variant" },
  { title: "columns", icon: "icon-function-variant" },
  { title: "row", icon: "icon-function-variant" },
  { title: "rows", icon: "icon-function-variant" },
  { title: "left", icon: "icon-function-variant" },
  { title: "right", icon: "icon-function-variant" },
  { title: "mid", icon: "icon-function-variant" },
  { title: "len", icon: "icon-function-variant" },
  { title: "replace", icon: "icon-function-variant" },
  { title: "round", icon: "icon-function-variant" },
  { title: "index", icon: "icon-function-variant" },
  { title: "match", icon: "icon-function-variant" },
  { title: "getifs", icon: "icon-function-variant" },
  { title: "hyperlink", icon: "icon-function-variant" },
  { title: "date", icon: "icon-function-variant" },
];

export const parameters = [
  { value: 0, title: "ignore nothing", icon: "icon-dots-horizontal", function: "getifs", parameterNo: 2 },
  { value: 1, title: "ignore zero", icon: "icon-dots-horizontal", function: "getifs", parameterNo: 2 },
  { value: 2, title: "ignore text", icon: "icon-dots-horizontal", function: "getifs", parameterNo: 2 },
  { value: 3, title: "ignore numbers", icon: "icon-dots-horizontal", function: "getifs", parameterNo: 2 },
  { value: 4, title: "ignore error values", icon: "icon-dots-horizontal", function: "getifs", parameterNo: 2 },
  { value: 5, title: "ignore hidden cells", icon: "icon-dots-horizontal", function: "getifs", parameterNo: 2 },
  { value: 1, title: "count", icon: "icon-function-variant", function: "getifs", parameterNo: 1 },
  { value: 2, title: "counta", icon: "icon-function-variant", function: "getifs", parameterNo: 1 },
  { value: 3, title: "sum", icon: "icon-function-variant", function: "getifs", parameterNo: 1 },
  { value: 4, title: "average", icon: "icon-function-variant", function: "getifs", parameterNo: 1 },
  { value: 5, title: "max", icon: "icon-function-variant", function: "getifs", parameterNo: 1 },
  { value: 6, title: "min", icon: "icon-function-variant", function: "getifs", parameterNo: 1 },
  { value: 7, title: "first", icon: "icon-function-variant", function: "getifs", parameterNo: 1 },
  { value: 8, title: "last", icon: "icon-function-variant", function: "getifs", parameterNo: 1 },
  { value: 9, title: "most", icon: "icon-function-variant", function: "getifs", parameterNo: 1 },
  { value: 10, title: "least", icon: "icon-function-variant", function: "getifs", parameterNo: 1 },

  // Aggregate functions
  { value: 1, title: "average", icon: "icon-function-variant", function: "aggregate", parameterNo: 0 },
  { value: 2, title: "count", icon: "icon-function-variant", function: "aggregate", parameterNo: 0 },
  { value: 3, title: "counta", icon: "icon-function-variant", function: "aggregate", parameterNo: 0 },
  { value: 4, title: "max", icon: "icon-function-variant", function: "aggregate", parameterNo: 0 },
  { value: 5, title: "min", icon: "icon-function-variant", function: "aggregate", parameterNo: 0 },
  { value: 6, title: "product", icon: "icon-function-variant", function: "aggregate", parameterNo: 0 },
  { value: 7, title: "stdev.s", icon: "icon-function-variant", function: "aggregate", parameterNo: 0 },
  { value: 8, title: "stdev.p", icon: "icon-function-variant", function: "aggregate", parameterNo: 0 },
  { value: 9, title: "sum", icon: "icon-function-variant", function: "aggregate", parameterNo: 0 },
  { value: 10, title: "var.s", icon: "icon-function-variant", function: "aggregate", parameterNo: 0 },
  { value: 11, title: "var.p", icon: "icon-function-variant", function: "aggregate", parameterNo: 0 },
  { value: 12, title: "median", icon: "icon-function-variant", function: "aggregate", parameterNo: 0 },
  { value: 13, title: "mode.sngl", icon: "icon-function-variant", function: "aggregate", parameterNo: 0 },
  { value: 14, title: "large", icon: "icon-function-variant", function: "aggregate", parameterNo: 0 },
  { value: 15, title: "small", icon: "icon-function-variant", function: "aggregate", parameterNo: 0 },

  // Aggregate behaviors
  {
    value: 0,
    title: "ignore nested SUBTOTAL and AGGREGATE functions",
    icon: "icon-dots-horizontal",
    function: "aggregate",
    parameterNo: 1,
  },
  {
    value: 1,
    title: "ignore hidden rows, nested SUBTOTAL and AGGREGATE functions",
    icon: "icon-dots-horizontal",
    function: "aggregate",
    parameterNo: 1,
  },
  {
    value: 2,
    title: "ignore error values, nested SUBTOTAL and AGGREGATE functions",
    icon: "icon-dots-horizontal",
    function: "aggregate",
    parameterNo: 1,
  },
  {
    value: 3,
    title: "ignore hidden rows, error values, nested SUBTOTAL and AGGREGATE functions",
    icon: "icon-dots-horizontal",
    function: "aggregate",
    parameterNo: 1,
  },
  { value: 4, title: "ignore nothing", icon: "icon-dots-horizontal", function: "aggregate", parameterNo: 1 },
  { value: 5, title: "ignore hidden rows", icon: "icon-dots-horizontal", function: "aggregate", parameterNo: 1 },
  { value: 6, title: "ignore error values", icon: "icon-dots-horizontal", function: "aggregate", parameterNo: 1 },
  {
    value: 7,
    title: "ignore hidden rows and error values",
    icon: "icon-dots-horizontal",
    function: "aggregate",
    parameterNo: 1,
  },
];

export const CompositeFunctions = ["getifs", "aggregate"];

export const typedFormulas = {
  date: "date",
  today: "date",
};
